import { z } from 'zod';

export const queueUploadRequestSchema = z
  .object({
    clipId: z.number(),
    baseLocalPath: z.string().optional(),
    verticalLocalPath: z.string().optional(),
  })
  .refine((body) => Boolean(body.baseLocalPath || body.verticalLocalPath), {
    message: 'At least one of baseLocalPath or verticalLocalPath must be provided',
  });

export type IQueueUploadRequest = z.infer<typeof queueUploadRequestSchema>;
